// Module
var code = `<div class="js-property-group-separator">
    <div class="js-tercera-label">{{.text}}</div>
</div>`;
// Exports
export default code;